// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Default_wrapper__YT9uS","btn":"Default_btn__ZLV24","isWideView":"Default_isWideView__LMtAu"};